/* @flow */
import { createSelector } from 'reselect';
import dayjs from 'dayjs';


export const allCalendarEventsSelectorRaw = (state: AppState) => state.calendar.events;

export const deserializeCalendarEvent = ({
  title, startDate, id, allDay, calendar, endDate,
}: SerializedCalendarItem): CalendarItem => ({
  isCalendarEvent: true,
  color: calendar.color,
  calendarId: calendar.id,
  allDay,
  title,
  postponedUntil: new Date(startDate),
  startDate: new Date(startDate),
  endDate: new Date(endDate),
  id,
});

export const calendarEventsBetween = createSelector(
  allCalendarEventsSelectorRaw,
  (_, { from }) => from,
  (_, { until }) => until,
  (allEvents, from, until) => allEvents
    .filter((e) => from < new Date(e.endDate) && until > new Date(e.startDate))
    .map(deserializeCalendarEvent),
);

export const calendarEventsRestOfDay = createSelector(
  allCalendarEventsSelectorRaw,
  () => dayjs().startOf('minute').valueOf(),
  () => dayjs().endOf('day').valueOf(),
  (allEvents, from, until) => allEvents
    .filter((e) => from < new Date(e.endDate) && until > new Date(e.startDate))
    .map(deserializeCalendarEvent),
);

export const selectedCalendarsSelector = createSelector(
  (state) => state.calendar.selectedCalendars,
  (selectedCalendars) => selectedCalendars,
);
